import * as React from 'react';

import { cn } from '../../lib/utils';

const TypographyH6 = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  // eslint-disable-next-line jsx-a11y/heading-has-content
  <h6
    ref={ref}
    className={cn('scroll-m-20 text-text-lg font-regular', className)}
    {...props}
  />
));
TypographyH6.displayName = 'TypographyH6';

export { TypographyH6 };
